import { render, staticRenderFns } from "./PayNowSummary.vue?vue&type=template&id=5b1648e9&scoped=true"
import script from "./PayNowSummary.vue?vue&type=script&lang=ts"
export * from "./PayNowSummary.vue?vue&type=script&lang=ts"
import style0 from "./PayNowSummary.vue?vue&type=style&index=0&id=5b1648e9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1648e9",
  null
  
)

export default component.exports